import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { PageOptions } from '../../models/interfaces';
import { TailoredShareholdersService } from 'src/app/services/tailored-shareholders.service';

@Component({
    selector: 'app-tailored-shareholders',
    templateUrl: './tailored-shareholders.component.html',
    styleUrls: ['./tailored-shareholders.component.scss'],
    standalone: false
})
export class TailoredShareholdersComponent implements OnInit {
  public pageOptions: PageOptions = {
    title: '',
    description: '',
    disclosures: null,
    eReviewNumber: null,
    renderNavBar: false,
    tabs: [],
    selectedTab: 0,
    applicationId: null,
  };
  public loading = true;
  public spinner = false;
  public searchControl: FormControl = new FormControl();
  public currentPage: number = 1;
  public recordsPerPage: number = 100;
  public totalPages: number;
  public query: string = "";

  public allData = [];

  private sortSubject: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor(
    private tailoredShareholdersService: TailoredShareholdersService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  private sortFn = (a, b) => {
    return this.getFundName(a).localeCompare(this.getFundName(b));
  };

  ngOnInit() {
    this.pageOptions.title = this.route.snapshot.data?.title || '';
    this.pageOptions.description = this.route.snapshot.data?.description || '';
    this.pageOptions.renderNavBar = this.route.snapshot.data?.renderNavBar;
    this.pageOptions.disclosures = this.route.snapshot.data?.disclosures;
    this.pageOptions.applicationId = this.route.snapshot.data?.applicationId;
    this.loadData();
  }

  ngAfterViewInit() {
    this.searchControl.valueChanges.pipe(debounceTime(350), startWith(''), distinctUntilChanged()).subscribe((filter: string) => {
      this.allData = [];
      this.spinner = true;
      this.query = filter != null ? filter.trim() : "";
      if (this.query.length >= 2) {
        const query = this.query?.replace(/[^a-zA-Z0-9-&.%' ]/g, "");
        this.tailoredShareholdersService.getSearchedDocuments(query)
          .subscribe((res) => {
            this.spinner = false;
            this.allData = res;
            this.allData?.sort((a, b) => this.getFundName(a).localeCompare(this.getFundName(b)));
          }
          )
      }
      else {
        this.loadData();
        this.spinner = false;
      }
    })
  }

  private loadData(): void {
    let url = window.location.href.toString();
    this.loading = true;
    const appTypeParam = this.pageOptions.applicationId;
    this.allData = [];
    this.tailoredShareholdersService
      .getFundsDocuments(appTypeParam, this.currentPage, this.recordsPerPage)
      .subscribe((res) => {
        this.loading = false;
        this.allData = res.data;
        this.totalPages = Math.ceil(res.totalSize / this.recordsPerPage);
        this.allData?.sort((a, b) => this.getFundName(a).localeCompare(this.getFundName(b)));
      });
    if (url.includes('fundtype=')) {
      this.router.navigate(['prospectus/sec']);
    }
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.loadData();
  }

  isAscSort(): boolean {
    return this.sortSubject.getValue();
  }

  toggleSort(): void {
    this.sortSubject.next(!this.sortSubject.getValue());
    this.allData?.sort((a, b) => this.sortSubject.getValue() ? this.sortFn(a, b) : this.sortFn(b, a));;
  }

  trackByFn = (index: number, item: any) => {
    return this.getCusip(item);
  };

  getFundName(prospectus: any, clean: boolean = false): string {
    if (!prospectus) {
      return '';
    }

    return clean
      ? prospectus.fundInformation._cleanLegalName
      : prospectus.fundInformation.legalName || '';
  }

  getCusip(prospectus: any) {
    if (prospectus.fundInformation?.cusip) {
      return prospectus.fundInformation.cusip;
    }
    for (const key of Object.keys(prospectus.documents)) {
      if (prospectus.documents[key]?.securityId) {
        return prospectus.documents[key].securityId;
      }
    }
    return null;
  }


  openCusipLinkPopup(link: string): void {
    this.openLinkInNewWindow(link);
  }

  openLinkInNewWindow(link: string): void {
    window.open(
      link,
      'popup',
      'width=1024,height=768,left=10,top=10,location=no,resizable=yes,menubar=no,status=no,toolbar=no,scrollbars=yes'
    );
  }

  scrollTo(): void {

    setTimeout(() => {
      const footnote = document.getElementById('disclosures');
      footnote?.scrollIntoView({ behavior: 'smooth' });
      footnote?.focus({ preventScroll: true });
    }, 300);
  }
}